module.exports = __webpack_public_path__ + "media/images/icons/filter-13be7f8dbcb5cfc44e1d66387caabaaa.svg";